// The root: the language (the profile's, else the browser's, D63), the time zone (the profile's,
// else the browser's, APS-398), the theme and the outlet.
import { useQuery } from '@tanstack/react-query'
import { Outlet } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { meQuery } from '../api/queries'
import { browserLocale, I18nProvider, isLocale, type Locale } from '../i18n'
import { applyTheme, readTheme } from '../lib/theme'
import { Analytics } from './Analytics'

export function RootLayout() {
  const me = useQuery({ ...meQuery, throwOnError: false })
  const [fallback] = useState<Locale>(browserLocale)
  const profile = me.data?.user.locale
  const locale: Locale = isLocale(profile) ? profile : fallback
  useEffect(() => {
    document.documentElement.lang = locale
  }, [locale])
  useEffect(() => applyTheme(readTheme()), [])
  return (
    <I18nProvider locale={locale} timeZone={me.data?.user.time_zone}>
      <Outlet />
      <Analytics me={me.data} />
    </I18nProvider>
  )
}
